<template>
  <div>
    <forwarding-address-table
        ref="table"
        :url="indexUrl"
        :can-create="canCreate"
        :create-url="createUrl"
    ></forwarding-address-table>
    <dialog-form-wrapper></dialog-form-wrapper>
  </div>
</template>

<script>
import DialogFormWrapper from '../dialog-form-wrapper';
import ForwardingAddressTable from './table';

export default {
  components: {
    DialogFormWrapper,
    ForwardingAddressTable,
  },

  props: {
    indexUrl: null,
    createUrl: null,
    canCreate: {
      type: Boolean,
      default: false
    },
  },
}
</script>
